// Libraries
import React from 'react';

// Components
import { Page } from 'components/Page';
import { H1 } from 'components/Typography';
// Styles
import styles from './Feedback.module.scss';

const Feedback = (): React.ReactElement<typeof Page> => (
  <Page
    classes={{
      root: styles.Root,
      container: styles.Container
    }}
  >
    <H1>
      Обратная связь
    </H1>
  </Page>
);

// Exports
export default Feedback;
